<template>
  <div class="questionnaireTableCellInputContainer" :class="classes">
    <question-date
      v-if="template.type === 'DATE'"
      :id="template.id"
      v-validate="validations"
      class="questionnaireTableCellInput"
      :name="template.id"
      :placeholder="template.placeholder"
      :value="vModel"
      :readonly="!!template.readonly"
      @blur="onChange"
    />

    <question-text
      v-else
      :id="template.id"
      v-validate="validations"
      class="questionnaireTableCellInput"
      :name="template.id"
      :placeholder="template.placeholder"
      :value="vModel"
      :readonly="!!template.readonly"
      @input="onChange"
    />

    <tooltip
      :ord="template.ord"
      :title="template.name"
      :description="template.description"
      :required="!!isRequired"
      :error="showErrors && errors.first(template.id)"
    />
  </div>
</template>

<script>
  import QuestionnaireQuestionValidationMixin from '../mixins/QuestionnaireQuestionValidationMixin.vue'
  import QuestionDate from './QuestionnaireFormQuestionDate.vue'
  import QuestionText from './QuestionnaireFormQuestionText.vue'
  import Tooltip from '../tooltips/QuestionnaireTooltip.vue'

  export default {
    name: 'RbQuestionnaireFormQuestion',

    components: {
      QuestionDate,
      QuestionText,
      Tooltip
    },

    mixins: [ QuestionnaireQuestionValidationMixin ],

    props: [ 'globals', 'model', 'response', 'template' ],

    computed: {
      updatedTemplate () { return this.template }
    }
  }
</script>

<style lang="stylus">

  .questionnaireTableCellInput {
    width: 75px;
    min-width: 100%;
    height: 26px;
    background: white;
    border: 1px solid #DCDEE0;
    border-radius: 2px;
    box-sizing: border-box;
    font-size: 12px;
    line-height: 26px;
    padding: 0 3px;
    color: #546E7A;
    font-family: "Noto Sans";

    &::-webkit-input-placeholder {
      color: #B0BEC5;
    }

    &:-moz-placeholder {
      color: #B0BEC5;
    }

    &:-ms-input-placeholder {
      color: #B0BEC5;
    }
  }

  .questionnaireTableCellInputContainer {
    padding 3px

    &.required {
      background-color: #fefcd3
    }

    &.error {
      background-color: #f15a24;
    }
  }

</style>
